import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["products_au"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { uniqBy } from 'lodash';
const TWO = 2;

function reduceCategorySlugToLevel(slug, level) {
  return slug.split('/').slice(0, level).join('/');
}

function categorySlugLevel(slug) {
  return slug.split('/').length;
}

function filterRedundantLevel1s(productSuggestions, threshold) {
  const level2s = productSuggestions.filter(maybeL2 => categorySlugLevel(maybeL2.productsCategory.slug) === TWO);
  return productSuggestions.filter(hit => {
    if (categorySlugLevel(hit.productsCategory.slug) !== 1) {
      return true;
    }

    const matchingLevel2 = level2s.find(l2 => hit.productsCategory.slug === reduceCategorySlugToLevel(l2.productsCategory.slug, 1));

    if (!matchingLevel2) {
      return true;
    }

    return matchingLevel2.productsCategory.count / hit.productsCategory.count <= threshold;
  });
}

function splitSuggestionBaseHit(categorySlugToHeaderMapping, hit) {
  var _products_au$facets$e, _products_au$facets, _products_au$facets$e2;

  /* eslint-disable camelcase */
  const {
    products_au
  } = hit,
        base = _objectWithoutProperties(hit, _excluded); // Note that while Algolia calls the property "category" it is
  // in fact an array of categories


  const categories = (_products_au$facets$e = (_products_au$facets = products_au.facets) === null || _products_au$facets === void 0 ? void 0 : (_products_au$facets$e2 = _products_au$facets.exact_matches) === null || _products_au$facets$e2 === void 0 ? void 0 : _products_au$facets$e2.category) !== null && _products_au$facets$e !== void 0 ? _products_au$facets$e : [];
  const split = categories.map(_ref => {
    let {
      value,
      count
    } = _ref;
    // If this is an L3 or L4 we don't have a title for it in the
    // mapping so we truncate to an L2
    const slug = reduceCategorySlugToLevel(value, TWO);
    const displayTitle = categorySlugToHeaderMapping[slug];
    return _objectSpread(_objectSpread({}, base), {}, {
      productsCategory: {
        slug,
        count,
        displayTitle
      },
      objectID: "".concat(base.objectID, ":").concat(slug)
    });
  }).filter(transformedHit => Boolean(transformedHit.productsCategory.displayTitle));
  return uniqBy(split, 'productsCategory.slug');
  /* eslint-enable camelcase */
}

const REDUNDANCY_THRESHOLD = 0.9;
export default function transformQuerySuggestionHits(categorySlugToHeaderMapping, hits) {
  const split = hits.flatMap(hit => splitSuggestionBaseHit(categorySlugToHeaderMapping, hit));
  return filterRedundantLevel1s(split, REDUNDANCY_THRESHOLD);
}